import { Store } from '@ngrx/store';
import { Injectable, Inject, inject } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { AosEditOnlineService } from '@adw/projects/aca-content/ms-office/src/aos-extension.service';
import { RAW_AOS_SERVICE } from './tokens';
import { AppStore } from '../store/states';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';
import { DocumentListService } from '@alfresco/adf-content-services';

@Injectable({
  providedIn: 'root',
})
export class WkAosExtensionService {
  private readonly documentListService = inject(DocumentListService);
  constructor(
    @Inject(RAW_AOS_SERVICE) private readonly base: AosEditOnlineService,
    private readonly store: Store<AppStore>,
    private readonly api: WkAlfrescoApiService
  ) {}

  public async onActionEditOnlineAos(node: Node) {
    this.base.onActionEditOnlineAos(node);
    try {
      await this.lockNode(node.id);
      this.documentListService.reload();
    } catch {
      this.onLockError(node);
    }
  }

  private lockNode(nodeId: string) {
    return this.api.nodesApi.lockNode(nodeId, {
      type: 'ALLOW_OWNER_CHANGES',
      lifetime: 'PERSISTENT',
    });
  }

  onLockError(node: Node) {
    this.store.dispatch(
      new SnackbarErrorAction('APP.MESSAGES.ERRORS.LOCK_NODE', {
        fileName: node.name,
      })
    );
  }
}
